// Natua Parceiros application form (02/11/2026): one contact form, two tracks.
// The radio named contact[Trilha] picks the track; the matching <fieldset data-track>
// is enabled and shown, the other is disabled so its required fields neither block
// the submit nor get sent. Links with data-track-pick preselect a track.
// Approval queue: before the contact form is sent, the applicant is registered as a
// customer through a background customer form (e-mail, first name, tags
// parceiro-em-analise + trilha-<track>, e-mail consent). Whatever happens to that
// request, the contact form is then sent, so the store always gets the answers.
class TrackForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.radios = Array.from(this.querySelectorAll('input[type="radio"][data-track-radio]'));
    this.fieldsets = Array.from(this.querySelectorAll('fieldset[data-track]'));
    this.status = this.querySelector('[data-form-status]');
    this.sending = false;

    this.onChange = () => this.sync();
    this.radios.forEach((radio) => radio.addEventListener('change', this.onChange));

    this.onPick = (event) => {
      const link = event.target.closest('[data-track-pick]');
      if (!link) return;
      const track = link.getAttribute('data-track-pick');
      const radio = this.radios.find((item) => item.getAttribute('data-track-radio') === track);
      if (radio) {
        radio.checked = true;
        this.sync();
      }
    };
    document.addEventListener('click', this.onPick);

    this.onSubmit = (event) => this.handleSubmit(event);
    if (this.form) this.form.addEventListener('submit', this.onSubmit);

    this.sync();
  }

  disconnectedCallback() {
    this.radios.forEach((radio) => radio.removeEventListener('change', this.onChange));
    document.removeEventListener('click', this.onPick);
    if (this.form) this.form.removeEventListener('submit', this.onSubmit);
  }

  sync() {
    const track = this.currentTrack();
    this.fieldsets.forEach((fieldset) => {
      const active = fieldset.getAttribute('data-track') === track;
      fieldset.disabled = !active;
      fieldset.hidden = !active;
    });
  }

  currentTrack() {
    const checked = this.radios.find((radio) => radio.checked);
    return checked ? checked.getAttribute('data-track-radio') : '';
  }

  async handleSubmit(event) {
    if (this.sending) {
      event.preventDefault();
      return;
    }
    event.preventDefault();
    this.sending = true;
    this.setBusy(true);

    try {
      await this.registerCustomer();
    } catch (error) {
      // The contact e-mail below still carries the whole application.
    }

    HTMLFormElement.prototype.submit.call(this.form);
  }

  setBusy(busy) {
    const button = this.form.querySelector('[type="submit"]');
    if (button) {
      button.disabled = busy;
      button.setAttribute('aria-busy', busy ? 'true' : 'false');
    }
    if (this.status) this.status.textContent = busy ? this.getAttribute('data-sending-label') || '' : '';
  }

  async registerCustomer() {
    const url = this.getAttribute('data-customer-url');
    const email = this.form.querySelector('input[name="contact[email]"]');
    if (!url || !email || !email.value) return;

    const name = this.form.querySelector('input[name="contact[name]"]');
    const consent = this.form.querySelector('[data-email-consent]');
    const tags = [this.getAttribute('data-queue-tag'), `trilha-${this.currentTrack()}`].filter(Boolean).join(',');

    const body = new FormData();
    body.append('form_type', 'customer');
    body.append('utf8', '✓');
    body.append('contact[email]', email.value.trim());
    if (name && name.value) body.append('contact[first_name]', name.value.trim());
    body.append('contact[tags]', tags);
    if (consent && consent.checked) body.append('contact[accepts_marketing]', 'true');

    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 6000);
    try {
      await fetch(url, { method: 'POST', body, credentials: 'same-origin', signal: controller.signal });
    } finally {
      clearTimeout(timer);
    }
  }
}

if (!customElements.get('s-track-form')) customElements.define('s-track-form', TrackForm);
